// @mui
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
//
import TourGuideUserMappingEditForm from '../tour-guide-user-mapping-edit-form';

// ----------------------------------------------------------------------

export default function TourGuideItemView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Asign Tour Guide Schema "
        links={[
          {
            name: 'Dashboard',
            href: paths.dashboard.root,
          },
          {
            name: 'Tour Guides',
            href: paths.dashboard.tourGuide.root,
          },
          { name: 'Asign' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <TourGuideUserMappingEditForm />
    </Container>
  );
}
